export const hardwareList = [
    {
        id: 1,
        title: "Resturant kit",
        desc: 'with mobile connection',
        price: 34,
        category: 'deal',
        vat: "£40.80 incl.VAT",
        img: "https://images.ctfassets.net/txhaodyqr481/3IUttqvXWw6ok2WIEwEiqY/83c2867d7610b476fe79f341d43c88e3/Air_Comparison.png?fm=avif&q=85&w=912&h=912"
    },

    {
        id: 2,
        title: "Cafe Kit",
        desc: 'with hands-free display',
        price: 79,
        category: 'deal',
        vat: '£40.80 incl.VAT',
        img: "https://images.ctfassets.net/txhaodyqr481/6Cj8NrOQJRDSGHQLTdgAJC/f741f46415a58a62a55462cd0b6a3024/Air_Cradle-sideview.png?fm=avif&q=85&w=912&h=912"
    },

    {
        id: 3,
        title: "Retail",
        desc: 'with advanced features',
        price: 139,
        category: 'deal',
        vat: "£40.80 incl.VAT",
        img: "https://images.ctfassets.net/txhaodyqr481/5Zk1aKzaIiIB1EC84UMm30/77fafc074f71829a203778885866ddfd/Solo_nfc.png?fm=avif&q=85&w=912&h=912"
    },

    {
        id: 4,
        title: "Grocery shop Kit",
        desc: 'with advanced features',
        price: 169,
        category: 'deal',
        vat: "£40.80 incl.VAT",
        img: "https://images.ctfassets.net/txhaodyqr481/3uXiTzKdoP9Iogplvkm98R/1ca1b2bc7d1b9c0dee13486a3dfa65f3/SOLO_AND_PRINTER_1X1_CLEAR.png?fm=avif&q=85&w=912&h=912"
    },

    {
        id: 5,
        title: "Beauty Solution kit",
        desc: 'with essential POS features',
        price: 169,
        category: 'deal',
        vat: "£40.80 incl.VAT",
        img: "https://images.ctfassets.net/txhaodyqr481/DcPOTHxOzvjNCcen8mH58/0753910c0522fea798a463b6e61279b8/EN_Terminal_Shop_-1_NEW.png?fm=avif&q=85&w=912&h=912"
    },

    {
        id: 6,
        title: "C20 Pro Mono",
        desc: 'with advanced features',
        price: 34,
        category: 'pos_terminal',
        vat: "£40.80 incl.VAT",
        img: "https://images.ctfassets.net/txhaodyqr481/j2jetOMwmb3zhXoUq1WH1/cfc1312172029641cc71f6522e72a820/global.png?fm=avif&q=85&w=912&h=912"
    },

    {
        id: 7,
        title: "C20 Pro Dual",
        desc: 'with advanced features',
        price: 67,
        category: 'pos_terminal',
        vat: "£40.80 incl.VAT",
        img: "https://images.ctfassets.net/txhaodyqr481/5zejyAEMSHk4XQgjNnQ1T0/5d6a3100423cf647af1555f5c1ae8136/Pos_Pro_bundle_UK.png?fm=avif&q=85&w=912&h=912"
    },

    {
        id: 8,
        title: "C20 SE Mono",
        desc: 'with mobile connection',
        price: "0",
        category: 'pos_terminal',
        vat: "£40.80 incl.VAT",
        img: "https://images.ctfassets.net/txhaodyqr481/7gfctV6TSLGM9MANnW5rRs/efdc17ded35e9444236638af45cc708a/IMAGE_WEB__Android_GB.png?fm=avif&q=85&w=912&h=912"
    },

    {
        id: 9,
        title: "C20 SE Dual",
        desc: 'with mobile connection',
        price: "120",
        category: 'pos_terminal',
        vat: "£40.80 incl.VAT",
        img: "https://images.ctfassets.net/txhaodyqr481/7gfctV6TSLGM9MANnW5rRs/efdc17ded35e9444236638af45cc708a/IMAGE_WEB__Android_GB.png?fm=avif&q=85&w=912&h=912"
    },

    {
        id: 10,
        title: "Imin 16",
        desc: 'with mobile connection',
        price: "120",
        category: 'kiosk',
        vat: "£40.80 incl.VAT",
        img: "https://images.ctfassets.net/txhaodyqr481/7gfctV6TSLGM9MANnW5rRs/efdc17ded35e9444236638af45cc708a/IMAGE_WEB__Android_GB.png?fm=avif&q=85&w=912&h=912"
    },
    {
        id: 11,
        title: "Imin 27",
        desc: 'with mobile connection',
        price: "120",
        category: 'kiosk',
        vat: "£40.80 incl.VAT",
        img: "https://images.ctfassets.net/txhaodyqr481/7gfctV6TSLGM9MANnW5rRs/efdc17ded35e9444236638af45cc708a/IMAGE_WEB__Android_GB.png?fm=avif&q=85&w=912&h=912"
    },
    {
        id: 12,
        title: "Imin 22",
        desc: 'with mobile connection',
        price: "120",
        category: 'kiosk',
        vat: "£40.80 incl.VAT",
        img: "https://images.ctfassets.net/txhaodyqr481/7gfctV6TSLGM9MANnW5rRs/efdc17ded35e9444236638af45cc708a/IMAGE_WEB__Android_GB.png?fm=avif&q=85&w=912&h=912"
    },

    {
        id: 13,
        title: "Imin 32",
        desc: 'with mobile connection',
        price: "120",
        category: 'kiosk',
        vat: "£40.80 incl.VAT",
        img: "https://images.ctfassets.net/txhaodyqr481/7gfctV6TSLGM9MANnW5rRs/efdc17ded35e9444236638af45cc708a/IMAGE_WEB__Android_GB.png?fm=avif&q=85&w=912&h=912"
    },

    {
        id: 14,
        title: "Sunmi k1",
        desc: 'with mobile connection',
        price: "120",
        category: 'kiosk',
        vat: "£40.80 incl.VAT",
        img: "https://images.ctfassets.net/txhaodyqr481/7gfctV6TSLGM9MANnW5rRs/efdc17ded35e9444236638af45cc708a/IMAGE_WEB__Android_GB.png?fm=avif&q=85&w=912&h=912"
    },

    {
        id: 15,
        title: "Sunmi k2",
        desc: 'with mobile connection',
        price: "120",
        category: 'kiosk',
        vat: "£40.80 incl.VAT",
        img: "https://images.ctfassets.net/txhaodyqr481/7gfctV6TSLGM9MANnW5rRs/efdc17ded35e9444236638af45cc708a/IMAGE_WEB__Android_GB.png?fm=avif&q=85&w=912&h=912"
    },

    {
        id: 16,
        title: "Wisepad",
        desc: 'with mobile connection',
        price: "120",
        category: 'payment',
        vat: "£40.80 incl.VAT",
        img: "https://images.ctfassets.net/txhaodyqr481/7gfctV6TSLGM9MANnW5rRs/efdc17ded35e9444236638af45cc708a/IMAGE_WEB__Android_GB.png?fm=avif&q=85&w=912&h=912"
    },

    {
        id: 17,
        title: "S700",
        desc: 'with mobile connection',
        price: "120",
        category: 'payment',
        vat: "£40.80 incl.VAT",
        img: "https://images.ctfassets.net/txhaodyqr481/7gfctV6TSLGM9MANnW5rRs/efdc17ded35e9444236638af45cc708a/IMAGE_WEB__Android_GB.png?fm=avif&q=85&w=912&h=912"
    },

    {
        id: 18,
        title: "Landi M20",
        desc: 'with mobile connection',
        price: "120",
        category: 'mPos',
        vat: "£40.80 incl.VAT",
        img: "https://images.ctfassets.net/txhaodyqr481/7gfctV6TSLGM9MANnW5rRs/efdc17ded35e9444236638af45cc708a/IMAGE_WEB__Android_GB.png?fm=avif&q=85&w=912&h=912"
    },

    {
        id: 18,
        title: "Imon Falcon 2",
        desc: 'with mobile connection',
        price: "120",
        category: 'mPos',
        vat: "£40.80 incl.VAT",
        img: "https://images.ctfassets.net/txhaodyqr481/7gfctV6TSLGM9MANnW5rRs/efdc17ded35e9444236638af45cc708a/IMAGE_WEB__Android_GB.png?fm=avif&q=85&w=912&h=912"
    },

    {
        id: 19,
        title: "Printer",
        desc: 'with printer connection',
        price: "120",
        category: 'accessories',
        vat: "£40.80 incl.VAT",
        img: "https://images.ctfassets.net/txhaodyqr481/7gfctV6TSLGM9MANnW5rRs/efdc17ded35e9444236638af45cc708a/IMAGE_WEB__Android_GB.png?fm=avif&q=85&w=912&h=912"
    },


]


export const CategoryList = [
    {
        id: 1,
        img: "https://www.grafterr.com/gb/admin/assets/uploads/52655511point-of-sale-cat-image.png",
        title: "Fusion deals",
        key: 'deal',
        desc: "Powerful POS terminals that can keep up"
    },
    {
        id: 2,
        img: "https://www.grafterr.com/gb/admin/assets/uploads/1224329551self-service-kiosks-cat-image.png",
        title: "Pos Terminal",
        key: 'pos_terminal',
        desc: "The Future of Customer Ordering"
    },
    {
        id: 3,
        img: "https://www.grafterr.com/gb/admin/assets/uploads/99523964accessories-cat-image.png",
        title: "Kiosk",
        key: 'kiosk',
        desc: "Add New devices to your POS setup"
    },
    {
        id: 4,
        img: "https://www.grafterr.com/gb/admin/assets/uploads/1479556089payment-devices-cat-image.png",
        title: "Payment",
        key: 'payment',
        desc: "Flexible. low cost payment devices"
    },

    {
        id: 5,
        img: "https://www.grafterr.com/gb/admin/assets/uploads/1479556089payment-devices-cat-image.png",
        title: "Mobile POS",
        key: 'mPos',
        desc: "Flexible. low cost payment devices"
    },

    {
        id: 5,
        img: "https://www.grafterr.com/gb/admin/assets/uploads/1479556089payment-devices-cat-image.png",
        title: "Accessories",
        key: 'accessories',
        desc: "Flexible. low cost payment devices"
    }

]